export class SetIsMenuOpenAction {
  public static readonly type = '[View] Set menu is open or closed';
  constructor(public isMenuOpen: boolean) {}
}
